import { useEffect, useState } from 'react'

import { useHasOwnCoachWorkspace } from '@/hooks/useHasOwnCoachWorkspace'
import { useMyCoachProfile } from '@/hooks/useMyCoachProfile'
import { imageLoads } from '@/lib/coachPhoto'

/** The signed-in coach's photo, only once it has loaded, so a broken link leaves the Clerk image in place. */
export function useOwnCoachPhoto(): string | null {
  const { hasOwnCoachWorkspace } = useHasOwnCoachWorkspace()
  const { profile } = useMyCoachProfile(hasOwnCoachWorkspace)
  const photoUrl = profile?.photo_url ?? null
  const [loadedUrl, setLoadedUrl] = useState<string | null>(null)

  useEffect(() => {
    if (!photoUrl) return
    let current = true
    // The page's own referrer policy, because the Clerk avatar background and the header image load under it.
    void imageLoads(photoUrl, '').then((loaded) => {
      if (current && loaded) setLoadedUrl(photoUrl)
    })
    return () => {
      current = false
    }
  }, [photoUrl])

  return photoUrl && photoUrl === loadedUrl ? photoUrl : null
}
